import { Settings } from 'lucide-react';
import { lazy } from 'react';

import { ROUTES } from '@/platform/router/routes';

import { label, type FeatureModule } from './contracts';

const AccountPage = lazy(() =>
  import('@/app/core/app/admin/pages/AccountPage').then((m) => ({
    default: m.AccountPage,
  })),
);

const SettingsNavigation = lazy(() =>
  import('@/platform/settings/SettingsNavigation').then((m) => ({
    default: m.SettingsNavigation,
  })),
);

/** `/app/account`: reached from the user dropdown, never listed in the nav. */
export const accountModule: FeatureModule = {
  id: 'account',
  // Staff have a profile too: password, MFA and sessions are personal routes.
  audience: 'all',
  routes: [{ path: 'account/*', to: ROUTES.account, Component: AccountPage }],
};

/** `/app/settings`: the composable hub plus the footer nav entry. */
export const settingsModule: FeatureModule = {
  id: 'settings',
  // The hub filters its own sections by audience; staff keep appearance and language.
  audience: 'all',
  routes: [{ path: 'settings/*', to: ROUTES.settings, Component: SettingsNavigation }],
  footerNav: [
    {
      order: 100,
      to: ROUTES.settings,
      label: label('global', 'sidebar_settings_label'),
      icon: Settings,
    },
  ],
};

/** Modules every dashboard mounts. Spread first in `AppDefinition.modules`. */
export const coreModules: FeatureModule[] = [accountModule, settingsModule];
